import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { localeI18nText } from './localeI18nText';
const triggerAlert = (key, locale, type) => {
  FloatingAlertStore.addAlert({
    titleText: localeI18nText(`app.error.${key}.title`, locale),
    message: localeI18nText(`app.error.${key}.body`, locale),
    type,
    'data-test-id': `${key}-${type}-alert`
  });
};
export const genericSubmitErrorAlert = locale => {
  triggerAlert('submit', locale, 'danger');
};
export const rateLimitErrorAlert = locale => {
  triggerAlert('rateLimitAlert', locale, 'danger');
};